import { cn } from '@/utils/cn'

type DealPanelTextareaProps = {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  placeholder?: string
  rows?: number
  attention?: boolean
  invalid?: boolean
  id?: string
  'aria-label'?: string
}

export function DealPanelTextarea({
  value,
  onChange,
  onBlur,
  placeholder,
  rows = 3,
  attention = false,
  invalid = false,
  id,
  'aria-label': ariaLabel,
}: DealPanelTextareaProps) {
  return (
    <div
      className={cn(
        'w-full overflow-hidden rounded-lg transition-colors',
        attention
          ? cn(
              'field-attention-shell min-h-[96px] border-2 border-warning bg-white/[0.04] px-3.5 py-2.5',
              'hover:border-warning/80 hover:bg-white/[0.06]',
              'focus-within:ring-2 focus-within:ring-warning/30',
            )
          : cn(
              'deal-panel-field-shell border border-white/[0.08] bg-white/[0.04] px-3.5 py-2.5',
              'hover:border-white/[0.12] hover:bg-white/[0.06]',
              'focus-within:border-accent/40 focus-within:ring-2 focus-within:ring-accent/15',
              invalid && 'border-amber-400/50',
            ),
      )}
    >
      <textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        rows={rows}
        placeholder={placeholder}
        aria-label={ariaLabel}
        aria-invalid={invalid || undefined}
        className="w-full resize-none border-0 bg-transparent p-0 text-sm leading-relaxed text-text-primary outline-none focus:ring-0 placeholder:text-text-muted"
      />
    </div>
  )
}
